export const Domain = import.meta.env.VITE_API_ENDPOINT ?? "http://127.0.0.1";
export const ApiEndpoint = `${Domain}/api/panel`;

export const AuthTokenName = "byotime-login";
export const isProduction = import.meta.env.PROD;
